import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import Login from './layout/Login/Login';
import './App.css';
import { selectAuth } from './features/auth/authSlice';
import { useAppSelector } from './core/hooks';
import NotFound from './layout/NotFound/NotFound';
import 'primeflex/primeflex.css';
import Spinner from './components/Spinner/Spinner';
import ForgotPassword from './layout/ForgotPassword/ForgotPassword';
import ResetPassword from './layout/ForgotPassword/ResetPassword';
import LogHistory from './layout/Home/LogHistory/LogHistory';
import CreateAnnounce from './layout/Home/CreateAnnounce/CreateAnnounce';
import Preview from './layout/Preview/Preview';
import Calender from './layout/Home/Calender/Calender';
import { toast, ToastContainer } from 'react-toastify';
import Background from './layout/Home/Background/Background';
import Template from './layout/Home/Template/Template';
import AddTemplate from './layout/Home/Template/AddTemplate';
import { Switch } from '@mui/material';
import ChangePassword from './layout/Home/ChangePassword/ChangePassword';
import AnnouncementGard from './layout/Announcement/Announcement';
import ExpiredLicense from './components/ExpiredLicense/ExpiredLicense';
import axiosInstance from './core/axiosInstance';
import { useEffect } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import Insights from './layout/Home/insights/Insights';

function App() {
  const auth = useAppSelector(selectAuth);
  const token = localStorage.getItem('userToken');
  const Home = lazy(() => import('./layout/Home/Home'));
  const announcementKey: string | null = localStorage.getItem('announcement-key');

  return (
    <Router>
      <Suspense fallback={<Spinner />}>
        <ConfirmDialog />
        <Routes>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/forgotPassword" element={<ForgotPassword />}></Route>
          <Route path="/resetPassword" element={<ResetPassword />}></Route>
          <Route path="/expired" element={<ExpiredLicense />}></Route>

          <Route
            path="/pages/:id"
            element={announcementKey ? <Preview /> : <AnnouncementGard />}
          ></Route>
          <Route
            path="/"
            element={!!token || auth.isAuth ? <Home /> : <Navigate to="/login" />}
          >
            <Route path="/loghistory" element={<LogHistory />} />
            <Route path="/background" element={<Background />} />
            <Route path="/calender" element={<Calender />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/announcedetails" element={<CreateAnnounce />} />
            <Route path="/templates" element={<Template />} />
            <Route path="/add-template" element={<AddTemplate />} />
            <Route path="/changePassword" element={<ChangePassword />}></Route>
          </Route>
          <Route>pages</Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <ToastContainer />
      </Suspense>
    </Router>
  );
}

export default App;
